import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakTokenParsed, KeycloakProfile } from 'keycloak-js';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ChangePasswordModel, LoginUser } from './main-shared/class-models/login-model';
import { Customer, Unit, UserDetailsMainModel } from './user-details-model';
import { AccessMode } from './main-shared/class-models/accessMode';
import { Role } from './main-shared/class-models/role-model';
import { AccessModuleTabDetails } from './main-shared/class-models/module-details';
import { ApiResponse } from './main-shared/class-models/ApiResponse';
import { TelemetryService } from './telemetry.service';

@Injectable({
  providedIn: 'root'
})
export class AppServiceService {
  telemetry: TelemetryService = this.injector.get(TelemetryService);
  baseUrl?: string = '';
  isAuthenticated1 = false;
  public userSubject: BehaviorSubject<LoginUser>;
  public user: Observable<LoginUser>;
  public userDetailsSubject: BehaviorSubject<UserDetailsMainModel>;
  public userDetails: Observable<UserDetailsMainModel>;


  public selectedCustomerSubject: BehaviorSubject<Customer>;
  public selectedCustomer: Observable<Customer>;

  public selectedUnitSubject: BehaviorSubject<Unit>;
  public selectedUnit: Observable<Unit>;

  public hubConnectionSubject: BehaviorSubject<signalR.HubConnection>;
  public hubConnection: Observable<signalR.HubConnection>;

  public selectedPileSubject: BehaviorSubject<string>;
  public selectedPile: Observable<string>;

  constructor(
    private http: HttpClient,
    private router: Router,
    private injector: Injector,
    protected readonly keycloak: KeycloakService
  ) {
    this.baseUrl = environment.BASE_URL;
    this.userSubject = new BehaviorSubject<LoginUser>(JSON.parse(sessionStorage.getItem('userResponse')));
    this.user = this.userSubject.asObservable();

    this.userDetailsSubject = new BehaviorSubject<UserDetailsMainModel>(null);
    this.userDetails = this.userDetailsSubject.asObservable();

    this.selectedCustomerSubject = new BehaviorSubject<Customer>(null);
    this.selectedCustomer = this.selectedCustomerSubject.asObservable();

    this.selectedUnitSubject = new BehaviorSubject<Unit>(null);
    this.selectedUnit = this.selectedUnitSubject.asObservable();

    
    this.hubConnectionSubject = new BehaviorSubject<signalR.HubConnection>(null);
    this.hubConnection = this.hubConnectionSubject.asObservable();

    this.selectedPileSubject = new BehaviorSubject<string>(null);
    this.selectedPile = this.selectedPileSubject.asObservable();
    
    this.mapValues();
  }
  
  
  DEFAULT_PAGE_SIZE = 10; // No. of rows to show in each page in table pagination
  DEFAULT_ROWS_PAGE = [10, 15, 20, 25]; // Options for No. of rows to show in a page in table pagination
  DEFAULT_RADICAL_COUNT = 3; // Maximum number of quality radicals to show without the view more option
  
  async mapValues() {
    if (this.isLoggedIn()) {
      let userResponse = {
        email: (await this.loadUserProfile()).email,
        displayName: (await this.loadUserProfile()).username,
        token: this.getUserToken(),
        role: this.getLoggedUserRole()
      }

      // Map user data
      sessionStorage.setItem('Role', this.getLoggedUserRole())
      this.userSubject.next(userResponse);


      let selectedCust = sessionStorage.getItem('selectedCustomer') != 'undefined' ? JSON.parse(sessionStorage.getItem('selectedCustomer')) : null;
      if (selectedCust) {
        this.selectedCustomerSubject.next(selectedCust);
      }

      let selectedUnt = sessionStorage.getItem('selectedUnit') != 'undefined' ? JSON.parse(sessionStorage.getItem('selectedUnit')) : null;
      if (selectedUnt) {
        this.selectedUnitSubject.next(selectedUnt);
      }

      let currentUser = sessionStorage.getItem('userDetails') != 'undefined' ? JSON.parse(sessionStorage.getItem('userDetails')) : null;
      if (currentUser) {
        this.userDetailsSubject.next(currentUser);
      }
    }
  }


  public get userValue(): LoginUser {
    return this.userSubject.value;
  }
  public getLoggedUser(): KeycloakTokenParsed | undefined {
    try {
      const userDetails: KeycloakTokenParsed | undefined = this.keycloak.getKeycloakInstance().idTokenParsed;
      return userDetails;

    } catch (error) {
      console.error(error);
      return undefined;
    }
  }

  public getLoggedUserRole() {
    var roles = this.keycloak.getKeycloakInstance().tokenParsed.resource_access[environment.KeycloakConfig.clientId].roles
    if (roles.length > 0) {
      return roles[0]
    }
    else {
      return "";
    }
  }

  public getUserToken(): string {
    return this.keycloak.getKeycloakInstance().token;
  }

  public isLoggedIn(): Promise<boolean> {
    return this.keycloak.isLoggedIn();
  }

  public loadUserProfile(): Promise<KeycloakProfile> {
    return this.keycloak.loadUserProfile();
  }

  public login(): void {
    this.keycloak.login();
  }

  public logoutNew(): void {
    sessionStorage.clear();
    localStorage.clear();
    this.telemetry.setUser('');
    this.keycloak.logout(window.location.origin + "/" + environment.AppName);
  }

  logout() {
    this.isAuthenticated1 = false;
    //sessionStorage.setItem("userResponse", null)
    // this.currentUserSource.next(null);
    this.userSubject.next(null);
    sessionStorage.clear();
    localStorage.clear();
    // this.router.navigateByUrl('/account/login');
    this.keycloak.logout();
  }

  ChangePassword(loginModel: ChangePasswordModel): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl + "Login/ChangePassword", loginModel);
  }

  public redirectUserProfile(): void {
    this.keycloak.getKeycloakInstance().accountManagement();
  }

  public getRoles(): string[] {
    return this.keycloak.getUserRoles();
  }

  public getUserAccessLevel(): number {
    return Number(this.keycloak.getKeycloakInstance().tokenParsed["AccessLevel"]);
  }

  public getUserDetails(emailId: string): any {
    return this.http.get(this.baseUrl + `UserAccess/GetUserRolesModules?emailId=` + emailId);
  }

  SetAccessMode(moduleName: any, tabName?: any): AccessMode {
    // let lcRole = this.userSubject.value.role;
    let lcRole = sessionStorage.getItem('Role');
    if (lcRole == Role.test || lcRole == Role.masterAdmin) {
      return {
        view: true,
        edit: true,
        delete: true,
        show: true,
      }
    }
    switch (moduleName) {
      case AccessModuleTabDetails.MineConfigurationModule:
        {
          if (lcRole == Role.fh) {
            return {
              view: true,
              edit: false,
              delete: false,
              show: true,
            }
          }
          else if (lcRole === Role.dhMineMaintenance || lcRole === Role.dhMinesOperation || lcRole === Role.mineCellHo) {
            return {
              view: true,
              edit: true,
              delete: false,
              show: true,
            }
          }
        }
        break;

      case AccessModuleTabDetails.MinePlanningModule:
        {
          if (lcRole == Role.fh || lcRole == Role.drillBlastEngineer || lcRole == Role.mineOperationEngineer || lcRole == Role.dhMineMaintenance || lcRole == Role.maintenanceEngineer) {
            return {
              view: true,
              edit: false,
              delete: false,
              show: true,
            }
          }
          else if (lcRole == Role.mineCellHo || lcRole == Role.dhMinesOperation || lcRole == Role.planningEngineer) {
            return {
              view: true,
              edit: true,
              delete: false,
              show: true,
            }
          }
        }
        break;

      case AccessModuleTabDetails.MineOptimizationModule:
        {
          if (lcRole == Role.fh || lcRole == Role.drillBlastEngineer || lcRole == Role.dhMineMaintenance || lcRole == Role.maintenanceEngineer) {
            return {
              view: true,
              edit: false,
              delete: false,
              show: true,
            }
          }
          else if (lcRole == Role.mineCellHo || lcRole == Role.dhMinesOperation || lcRole == Role.mineOperationEngineer || lcRole == Role.planningEngineer) {
            return {
              view: true,
              edit: true,
              delete: false,
              show: true,
            }
          }
        }
        break;

      case AccessModuleTabDetails.DrillandBlastingModule:
        {
          if (lcRole == Role.mineCellHo || lcRole == Role.fh || lcRole == Role.planningEngineer || lcRole == Role.mineOperationEngineer
            || lcRole == Role.dhMineMaintenance || lcRole == Role.maintenanceEngineer) {
            return {
              view: true,
              edit: false,
              delete: false,
              show: true,
            }
          }
          else if (lcRole == Role.dhMinesOperation || lcRole == Role.drillBlastEngineer) {
            return {
              view: true,
              edit: true,
              delete: false,
              show: true,
            }
          }
        }
        break;

      case AccessModuleTabDetails.MineOperationsModule:
        {
          if (lcRole == Role.mineCellHo || lcRole == Role.fh || lcRole == Role.planningEngineer
            || lcRole == Role.drillBlastEngineer || lcRole == Role.dhMineMaintenance || lcRole == Role.maintenanceEngineer) {
            return {
              view: true,
              edit: false,
              delete: false,
              show: true,
            }
          }
          else if (lcRole == Role.dhMinesOperation || lcRole == Role.mineOperationEngineer) {
            return {
              view: true,
              edit: true,
              delete: false,
              show: true,
            }
          }
        }
        break;

      case AccessModuleTabDetails.GradeControlsModule:
        {
          if (tabName !== undefined) {
            if (tabName == AccessModuleTabDetails.QCLabTab) {
              if (lcRole == Role.mineCellHo || lcRole == Role.fh || lcRole == Role.planningEngineer || lcRole == Role.drillBlastEngineer
                || lcRole == Role.mineOperationEngineer || lcRole == Role.dhMineMaintenance || lcRole == Role.maintenanceEngineer) {
                return {
                  view: true,
                  edit: false,
                  delete: false,
                  show: true,
                }
              }
              else if (lcRole == Role.dhMinesOperation || lcRole == Role.qcAnalysisLab) {
                return {
                  view: true,
                  edit: true,
                  delete: false,
                  show: true,
                }
              }
            }
            else if (tabName == AccessModuleTabDetails.QualityTab) {
              if (lcRole == Role.mineCellHo || lcRole == Role.fh || lcRole == Role.drillBlastEngineer || lcRole == Role.mineOperationEngineer
                || lcRole == Role.dhMineMaintenance || lcRole == Role.maintenanceEngineer) {
                return {
                  view: true,
                  edit: false,
                  delete: false,
                  show: true,
                }
              }
              else if (lcRole == Role.dhMinesOperation || lcRole == Role.planningEngineer) {
                return {
                  view: true,
                  edit: true,
                  delete: false,
                  show: true,
                }
              }
              else if (lcRole == Role.qcAnalysisLab) {
                return {
                  view: false,
                  edit: false,
                  delete: false,
                  show: false,
                }
              }
            }
          }
        }
        break;

      case AccessModuleTabDetails.EquipmentMaintenanceModule:
        {
          if (tabName !== undefined) {
            if (lcRole == Role.mineOperationEngineer || lcRole == Role.dhMineMaintenance) {
              return {
                view: true,
                edit: true,
                delete: true,
                show: true,
              }
            }

            if (lcRole == Role.mineCellHo || lcRole == Role.fh || lcRole == Role.dhMinesOperation || lcRole == Role.planningEngineer
              || lcRole == Role.drillBlastEngineer) {
              return {
                view: true,
                edit: false,
                delete: false,
                show: true,
              }
            }

            if (lcRole == Role.maintenanceEngineer) {
              return {
                view: true,
                edit: true,
                delete: false,
                show: true,
              }
            }
          }
        }
        break;

      case AccessModuleTabDetails.MineInsightsModule:
        {
          if (lcRole == Role.coo || lcRole == Role.cmo || lcRole == Role.unitHead || lcRole == Role.mineCellHo || lcRole == Role.fh
            || lcRole == Role.dhMinesOperation || lcRole == Role.planningEngineer || lcRole == Role.drillBlastEngineer || lcRole == Role.mineOperationEngineer
            || lcRole == Role.dhMineMaintenance || lcRole == Role.maintenanceEngineer) {
            return {
              view: true,
              edit: false,
              delete: false,
              show: true,
            }
          }
        }
        break;
      default:
        return {
          view: true,
          edit: false,
          delete: false,
          show: true,
        }
    }

    return {
      view: true,
      edit: false,
      delete: false,
      show: true,
    }
  }
}
